let Color = require('./Color');

module.exports = class CoverArt {
    constructor() {
        /** @type {String} */   this.href   = null;
        /** @type {Number} */   this.height = null;
        /** @type {Number} */   this.width  = null;

        /** @type {Color} */
        this.primaryColor = null;
    }
};
